document.addEventListener("DOMContentLoaded", function(event) {

    // detail nemovitosti - presunuti brokera na reponzivu nad formular
    const broker = document.querySelector('.JS-detail-broker');
    resizeBroker();
    window.onresize = resizeBroker;

    function resizeBroker(){
        if (typeof (broker) !== 'undefined' && broker !== null){
            if(window.innerWidth < 980){
                if(document.querySelector('.JS-displaybroker-desktop .JS-detail-broker') !== null){
                    document.querySelector('.JS-displaybroker-desktop').removeChild(broker);
                    document.querySelector('.JS-displaybroker-mobile').appendChild(broker);
                }

            }else{
                if(document.querySelector('.JS-displaybroker-mobile .JS-detail-broker') !== null) {
                    document.querySelector('.JS-displaybroker-mobile').removeChild(broker);
                    document.querySelector('.JS-displaybroker-desktop').appendChild(broker);
                }
            }
        }
    }

});